module.exports = __webpack_public_path__ + "static/media/fire-smoke.31b888d4.svg";